export const ProjectAuthorRoleType = {
  MAKER: 'MAKER',
  HELPER: 'HELPER',
  IDEA: 'IDEA',
  DESIGN: 'DESIGN',
  MENTOR: 'MENTOR',
  SPONSOR: 'SPONSOR',
};

export const projectAuthorRoleTypes = [
  ProjectAuthorRoleType.MAKER,
  ProjectAuthorRoleType.HELPER,
  ProjectAuthorRoleType.IDEA,
  ProjectAuthorRoleType.DESIGN,
  ProjectAuthorRoleType.MENTOR,
  ProjectAuthorRoleType.SPONSOR,
];
